module.exports = __webpack_public_path__ + "static/img/icon_logo.2281308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_logo.png
// module id = xjsC
// module chunks = 1